export var ContentTypeServerEnum;
(function (ContentTypeServerEnum) {
    ContentTypeServerEnum[ContentTypeServerEnum["Split"] = -1] = "Split";
    ContentTypeServerEnum[ContentTypeServerEnum["Question"] = 1] = "Question";
    // Action = 2,
    ContentTypeServerEnum[ContentTypeServerEnum["Section"] = 3] = "Section";
    // Slide = 4,
    // Question = 5,
    ContentTypeServerEnum[ContentTypeServerEnum["BlindMapQuestion"] = 6] = "BlindMapQuestion";
    ContentTypeServerEnum[ContentTypeServerEnum["HotspotTab"] = 7] = "HotspotTab";
    ContentTypeServerEnum[ContentTypeServerEnum["Hotspot"] = 8] = "Hotspot";
    ContentTypeServerEnum[ContentTypeServerEnum["StartingMessage"] = 9] = "StartingMessage";
    // SequencedFlowHiddenArea = 10,
    // SequencedFlowSlide = 11,
    ContentTypeServerEnum[ContentTypeServerEnum["Resource"] = 12] = "Resource";
    ContentTypeServerEnum[ContentTypeServerEnum["SequencedFlowStep"] = 13] = "SequencedFlowStep";
})(ContentTypeServerEnum || (ContentTypeServerEnum = {}));
